import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=f038d7be&scoped=true&"
import script from "./createOrder.vue?vue&type=script&lang=js&"
export * from "./createOrder.vue?vue&type=script&lang=js&"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=f038d7be&prod&lang=scss&scoped=true&"
import style1 from "./createOrder.vue?vue&type=style&index=1&id=f038d7be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f038d7be",
  null
  
)

export default component.exports